// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";
import { colorProfileValidationObject } from "@dashboardApi/apis/engagementInAppMessageColorProfilesId";

export const isEngagementInAppMessageColorProfilesResult = objectOf({
  hits: number,
  results: arrayOf(colorProfileValidationObject),
});
